import {Pipe, PipeTransform} from '@angular/core';
import {AsYouType, format, parse} from 'libphonenumber-js';

@Pipe({
    name: 'macAddress',
    standalone: true
})
export class MacAddressPipe implements PipeTransform {
  transform(value: string, showValidation?: boolean): string {
    if (!value) {
      return value;
    }

    const addresses = value.split(' ');
    const formattedAddresses = [];
    for (const address of addresses) {
      formattedAddresses.push(this.formatMacAddress(address));
    }

    return formattedAddresses.join(' ');
  }

  formatMacAddress(macAddress) {

    if (macAddress) {
      let deviceMac = macAddress.toUpperCase();

      if (deviceMac.length >= 3 && deviceMac.length <= 16) {
        deviceMac = deviceMac.replace(/\W/ig, '');
        // deviceMac = deviceMac.replace(/(.{2})/g, "$1:");
        deviceMac = deviceMac
          .match(/.{1,2}/g).join(':');
      }

      return deviceMac;
    }

    return macAddress || '';
  }
}
